import { FC, PropsWithChildren } from 'react';
import { RecommendationsActivityType, RecommendationsResponse } from 'src/api/me/types';
import { createPortal } from 'react-dom';
import { MiniPlayer, MiniPlayerProps } from 'src/components/MiniPlayer';
import { ActivitySource } from 'src/utils/analytics/analytics.const';
import * as S from './styles';

type FloatingMiniPlayerProps = Omit<MiniPlayerProps, 'currentActivity' | 'recommendations'> & {
  currentActivity?: RecommendationsActivityType | null;
  recommendations?: RecommendationsResponse | null;
  source: ActivitySource;
  overlay?: boolean;
  isLoading?: boolean;
};

const Portal: FC<PropsWithChildren> = ({ children }) => {
  const domNode = document.querySelector('#floatingBottomPortalRoot');

  if (!domNode) {
    // eslint-disable-next-line no-console
    console.warn('Could not find floatingBottomPortalRoot');
    return null;
  }

  return createPortal(children, domNode);
};

export const FloatingMiniPlayer: FC<FloatingMiniPlayerProps> = ({
  currentActivity,
  recommendations,
  overlay,
  isLoading,
  ...restProps
}) => {
  if (!recommendations) {
    return null;
  }

  return (
    <Portal>
      <S.FullHeightPortal $overlay={overlay} data-testid="full-height-portal">
        <S.AnimatedContainer data-testid="floating-miniplayer">
          <MiniPlayer
            currentActivity={currentActivity || 'learn'}
            recommendations={recommendations}
            isLoading={isLoading}
            {...restProps}
          />
        </S.AnimatedContainer>
      </S.FullHeightPortal>
    </Portal>
  );
};
